/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WeekHours } from '../../models/week-hours';

export interface DaypartsDaypartIdStoresStoreIdPut$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;
  storeId: string;
      body: WeekHours
}

export function daypartsDaypartIdStoresStoreIdPut(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdStoresStoreIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdStoresStoreIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
    rb.path('storeId', params.storeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

daypartsDaypartIdStoresStoreIdPut.PATH = '/dayparts/{daypartId}/stores/{storeId}';
